import React from "react";
import "../../styles/DashboardStyling/ElasticSearchCard.css";
import SideBar from "./SideBar";
import ElasticSearch from "./ElasticSearch";

const ElasticSearchCard = ({
  userData,
  setUserData,
  isLoggedIn,
  setIsLoggedIn,
  selectedSponsor,
  selectedProject,
  setSelectedProject,
  setSelectedSponsor,
  onSponsorChange,
}) => {
  return (
    <div className="es-card-container">
      <div className="es-card-sidebar">
        <SideBar
          isLoggedIn={isLoggedIn}
          setIsLoggedIn={setIsLoggedIn}
          userData={userData}
          setUserData={setUserData}
          selectedSponsor={selectedSponsor}
          selectedProject={selectedProject}
          setSelectedProject={setSelectedProject}
          setSelectedSponsor={setSelectedSponsor}
          onSponsorChange={onSponsorChange}
        />
      </div>
      <div className="es-card-main">
        <ElasticSearch
          isLoggedIn={isLoggedIn}
          setIsLoggedIn={setIsLoggedIn}
          userData={userData}
          setUserData={setUserData}
          selectedSponsor={selectedSponsor}
          selectedProject={selectedProject}
          setSelectedProject={setSelectedProject}
          setSelectedSponsor={setSelectedSponsor}
          onSponsorChange={onSponsorChange}
        />
      </div>
    </div>
  );
};

export default ElasticSearchCard;
